import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const BCBenxekhachtable = React.memo(function BCBenxekhachtable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [sodonvi, setSodonvi] = React.useState(0);
  const [sotuyen_noitinh, setSotuyen_noitinh] = React.useState(0);
  const [sotuyen_lientinh, setSotuyen_lientinh] = React.useState(0);
  const [sotuyen_buyt, setSotuyen_buyt] = React.useState(0);
  const [sophuongtien_noitinh, setSophuongtien_noitinh] = React.useState(0);
  const [sophuongtien_lientinh, setSophuongtien_lientinh] = React.useState(0);
  const [sophuongtien_buyt, setSophuongtien_buyt] = React.useState(0);
  const [sochuyen_noitinh_th, setSochuyen_noitinh_th] = React.useState(0);
  const [tyle_chuyennoitinh, setTyle_chuyennoitinh] = React.useState(0);
  const [sochuyen_lientinh_th, setSochuyen_lientinh_th] = React.useState(0);
  const [tyle_chuyenlientinh, setTyle_chuyenlientinh] = React.useState(0);
  const [sochuyen_buyt_th, setSochuyen_buyt_th] = React.useState(0);
  const [sochuyen_noitinh_kth, setSochuyen_noitinh_kth] = React.useState(0);
  const [sochuyen_lientinh_kth, setSochuyen_lientinh_kth] = React.useState(0);
  const [sokhach_vanchuyen, setSokhach_vanchuyen] = React.useState(0);
  const [congsuatbenxe, setCongsuatbenxe] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Phuongtien/bcslthbenxekhach?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setSodonvi(data[0].sodonvi);
            setSotuyen_noitinh(data[0].sotuyen_noitinh);
            setSotuyen_lientinh(data[0].sotuyen_lientinh);
            setSotuyen_buyt(data[0].sotuyen_buyt);
            setSophuongtien_noitinh(data[0].sophuongtien_noitinh);
            setSophuongtien_lientinh(data[0].sophuongtien_lientinh);
            setSophuongtien_buyt(data[0].sophuongtien_buyt);
            setSochuyen_noitinh_th(data[0].sochuyen_noitinh_th);
            setTyle_chuyennoitinh(data[0].tyle_chuyennoitinh);
            setSochuyen_lientinh_th(data[0].sochuyen_lientinh_th);
            setTyle_chuyenlientinh(data[0].tyle_chuyenlientinh);
            setSochuyen_buyt_th(data[0].sochuyen_buyt_th);
            setSochuyen_noitinh_kth(data[0].sochuyen_noitinh_kth);
            setSochuyen_lientinh_kth(data[0].sochuyen_lientinh_kth);
            setSokhach_vanchuyen(data[0].sokhach_vanchuyen);
            setCongsuatbenxe(data[0].congsuatbenxe);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Tổng số bến xe khách</td>
          <td className={classes.tablebc_td}>Đơn vị</td>
          <td className={classes.tablebc_td}>{sodonvi}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>
            Tổng số tuyến xe xuất phát tại các bến xe
          </td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>
            {sotuyen_noitinh + sotuyen_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{sotuyen_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{sotuyen_lientinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến xe buýt</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{sotuyen_buyt}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Tổng số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>
            {sophuongtien_noitinh + sophuongtien_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien_lientinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến xe buýt</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien_buyt}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Tổng số chuyến xe thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>
            {sochuyen_noitinh_th + sochuyen_lientinh_th}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyen_noitinh_th}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>{tyle_chuyennoitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyen_lientinh_th}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>{tyle_chuyenlientinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>5</td>
          <td className={classes.tablebc_td}>Tổng số chuyến xe buýt</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyen_buyt_th}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>6</td>
          <td className={classes.tablebc_td}>
            Tổng số chuyến xe không thực hiện
          </td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>
            {sochuyen_noitinh_kth + sochuyen_lientinh_kth}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyen_noitinh_kth}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyen_lientinh_kth}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>7</td>
          <td className={classes.tablebc_td}>
            Tổng hành khách vận chuyển thông qua bến
          </td>
          <td className={classes.tablebc_td}>HK</td>
          <td className={classes.tablebc_td}>{sokhach_vanchuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>8</td>
          <td className={classes.tablebc_td}>Công suất bến xe</td>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>{congsuatbenxe}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table id="baocaobenxekhach" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCBenxekhachtable.propTypes = {
  thangnam: PropTypes.object,
};
export default BCBenxekhachtable;
